import { useState } from "react";
import { registerCustomer } from "../services/authService";
import { useLang } from "../i18n/LanguageContext";

export default function Register() {
  const { t } = useLang();
  const [form, setForm] = useState({
    email: "", password: "", name: "", companyName: "", phone: ""
  });
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    try {
      await registerCustomer(form);
      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    }
  }

  if (submitted) {
    return (
      <div className="auth-page">
        <h2>{t("requestReceived")}</h2>
        <p>{t("requestReceivedBody")}</p>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <h2>{t("createAccount")}</h2>
      <form onSubmit={handleSubmit}>
        <input name="companyName" placeholder={t("companyName")} onChange={handleChange} required />
        <input name="name" placeholder={t("contactName")} onChange={handleChange} required />
        <input name="phone" placeholder={t("phoneNumber")} onChange={handleChange} required />
        <input name="email" type="email" placeholder={t("email")} onChange={handleChange} required />
        <input name="password" type="password" placeholder={t("password")} onChange={handleChange} required minLength={6} />
        {error && <p className="error">{error}</p>}
        <button type="submit">{t("requestAccessBtn")}</button>
      </form>
    </div>
  );
}
